export default "__VITE_ASSET__BwfkQlvo__ 1200w";